type PerfEvent =
  | 'chat_load_cache'
  | 'chat_load_api'
  | 'scroll_anchor'
  | 'graph_dedup_hit'
  | 'idb_pagination_hit'
  | 'idb_pagination_miss';

interface PerfEntry {
  event: PerfEvent;
  chatId?: string;
  durationMs?: number;
  detail?: string;
}

class PerfLogger {
  private enabled = false;

  enable(): void {
    this.enabled = true;
  }

  disable(): void {
    this.enabled = false;
  }

  log(entry: PerfEntry): void {
    if (!this.enabled) return;
    console.debug('[Perf]', entry.event, entry);
  }

  /** Returns a stop function; calling it logs elapsed time. */
  time(label: string, chatId?: string): () => void {
    if (!this.enabled) return () => {};
    const start = performance.now();
    return () => {
      const durationMs = parseFloat((performance.now() - start).toFixed(2));
      console.debug(`[Perf] ${label}`, { chatId, durationMs });
    };
  }
}

export const perfLogger = new PerfLogger();
